import React from "react";

import img1 from "../../assets/images/architecture-2287327_1280.jpg";
import img2 from "../../assets/images/industry-construction-equipments-inside-storehouse-factory.jpg";
import img3 from "../../assets/images/logistic-center-with-desk-chairs (1).jpg";
import img4 from "../../assets/images/low-angle-view-scafolding-building.jpg";
import img5 from "../../assets/images/workers-examining-work.jpg";
import img6 from "../../assets/images/warehouse-storage-interior-with-shelves-loaded-with-goods.jpg";
import img7 from "../../assets/images/iron-steel-material-storage.jpg";
import img8 from "../../assets/images/view-geometric-buildings.jpg";

import img9 from '../../assets/projects/construction-271873_1920.jpg';
import img10 from '../../assets/projects/construction-site-3871804_1920.jpg';
import img11 from '../../assets/projects/pexels-cmrcn-29224601.jpg';
import img12 from '../../assets/projects/construction-site-1477687_1280.jpg';
import img13 from '../../assets/projects/chairs-2181980.jpg';
import img14 from '../../assets/projects/architecture-1850092.jpg';
import img15 from '../../assets/projects/construction-site-6609637.jpg';
import img16 from '../../assets/projects/construction-7226875.jpg';

// Top row images
const topImages = [img1, img2, img3, img4, img5, img6, img7, img8]; 
// Bottom row images
const bottomImages = [img9, img10, img11, img12, img13, img14, img15, img16];

const Slider = () => {
  return (
    <div className="bg-white py-10 px-4">
      <h2 className="text-4xl font-bold text-center mb-3 text-gray-800" style={{ color: 'deepskyblue' }}>
        Innovations in Modern Infrastructure
      </h2>
      <p className="text-center text-gray-600 text-lg mb-10 max-w-2xl mx-auto">
        Explore our recent breakthroughs across road and civil engineering. From EPC Structures to smart urban planning, we turn ideas into reality.
      </p>

      {/* Top Row (Left to Right) */}
      <div className="overflow-hidden mb-6">
        <div className="flex animate-marquee-right">
          {[...topImages, ...topImages].map((src, index) => (
            <img
              key={`top-${index}`}
              src={src}
              alt={`Top Project ${index + 1}`}
              loading="lazy"
              className="h-80 w-[30rem] object-cover mx-3 rounded-xl"
            />
          ))}
        </div>
      </div>

      {/* Bottom Row (Right to Left) */}
      <div className="overflow-hidden">
        <div className="flex animate-marquee-left">
          {[...bottomImages, ...bottomImages].map((src, index) => (
            <img
              key={`bottom-${index}`}
              src={src}
              alt={`Bottom Project ${index + 1}`}
              loading="lazy"
              className="h-80 w-[30rem] object-cover mx-3 rounded-xl"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Slider;
